import pluralize from 'pluralize'
import { HttpClient } from '@opallabs/api'
import { jsonApiWrapper } from '../../jsonApiParser'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const postBudget = ({ id, context, value }) =>
  HttpClient().post(`/budgets/${pluralize.plural(context)}/${id}`, value)

const createBudget = (options) => (dispatch, getState) =>
  postBudget(options)
    .then((response) => {
      const body = response.data
      if (options.callback) {
        options.callback()
      }

      if (body.data) {
        dispatch(loadJsonApiEntities(body))
        return jsonApiWrapper({
          data: getState().jsonApiEntities.budget[body.data.id],
          state: getState(),
        })
      }

      return {}
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default createBudget
